module.exports = __webpack_public_path__ + "img/Salon.4761e30d.jpg";